/**
 * Platform configuration adapter.
 *
 * Centralizes environment variable access and provides typed configuration.
 */

export interface PlatformConfig {
  /** API base URL for backend */
  apiBase: string
  /** Current environment */
  env: "development" | "staging" | "production"
  /** Debug mode enabled */
  debug: boolean
}

function getEnv(): PlatformConfig["env"] {
  const host = typeof window !== "undefined" ? window.location.hostname : ""
  if (host === "platform.getmazo.ai") return "production"
  if (host === "omega.getmazo.ai") return "staging"
  return "development"
}

function getApiBase(): string {
  // Environment variable takes precedence
  const envBase = import.meta.env.VITE_API_BASE_URL
  if (envBase) return envBase

  // Default based on environment
  const env = getEnv()
  switch (env) {
    case "production":
      return "https://api.getmazo.ai"
    case "staging":
      return "https://api-staging.getmazo.ai"
    default:
      return "http://localhost:4000"
  }
}

/** Platform configuration singleton */
export const config: PlatformConfig = {
  apiBase: getApiBase(),
  env: getEnv(),
  debug: import.meta.env.DEV ?? false,
}

/** Get the API base URL */
export function getConfig(): PlatformConfig {
  return config
}
